import { Link } from 'react-router-dom'

import type { BlogPost } from '../posts'

export type HomePageProps = {
  posts: BlogPost[]
}

export const HomePage = (props: HomePageProps) => {
  const { posts } = props

  return (
    <div className="blog-home">
      <div className="blog__wide">
        <header className="blog-home__intro">
          <p className="eyebrow">Notes from the club</p>
          <h1 className="display">Intentional dating, written down</h1>
          <p className="lede">
            Matchmaking craft, swipe culture, and how Revel thinks about connection — for people who
            want a match, not a feed.
          </p>
        </header>

        <ul className="blog-home__ledger">
          {posts.map((post) => (
            <li key={post.slug} className="blog-home__row">
              <Link className="blog-home__link" to={`/posts/${post.slug}`}>
                <time className="blog-home__date" dateTime={post.date}>
                  {formatDate(post.date)}
                </time>
                <div>
                  <h2 className="blog-home__post-title">{post.title}</h2>
                  <p className="blog-home__excerpt">{post.excerpt}</p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

function formatDate(iso: string) {
  const date = new Date(`${iso}T12:00:00`)
  return date.toLocaleDateString('en-CA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}
